
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"37.699","height":"29.261"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 729","fill":"none","stroke":"#088dd1","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.111"}},[_c('path',{attrs:{"data-name":"Path 6802","d":"M15.62 4.878H.555v23.827h13.609"}}),_c('path',{attrs:{"data-name":"Path 6803","d":"M18.849 3.582h0a4.685 4.685 0 00-4.685 4.685v20.438h9.373V8.267a4.685 4.685 0 00-4.688-4.685z"}}),_c('path',{attrs:{"data-name":"Path 6804","d":"M23.535 28.705h13.608V4.878H22.079"}}),_c('path',{attrs:{"data-name":"Path 6805","d":"M12.183 28.704v-7.679c0-2.128-3.014-3.049-3.014-4 0 .95-2.93 1.871-2.93 4v7.679"}}),_c('path',{attrs:{"data-name":"Path 6806","d":"M25.515 28.704v-7.679c0-2.128 3.014-3.049 3.014-4 0 .95 2.93 1.871 2.93 4v7.679"}}),_c('path',{attrs:{"data-name":"Line 32","d":"M.555 8.176h13.608"}}),_c('path',{attrs:{"data-name":"Line 33","d":"M37.143 8.176H23.535"}}),_c('path',{attrs:{"data-name":"Path 6807","d":"M33.576 4.878V.719H4.122v4.159"}}),_c('g',{attrs:{"data-name":"Group 590"}},[_c('path',{attrs:{"data-name":"Path 6808","d":"M6.441 8.176a2.017 2.017 0 10-4.034 0"}}),_c('path',{attrs:{"data-name":"Path 6809","d":"M12.32 8.176a2.017 2.017 0 10-4.034 0"}})]),_c('g',{attrs:{"data-name":"Group 591"}},[_c('path',{attrs:{"data-name":"Path 6810","d":"M31.259 8.176a2.017 2.017 0 114.034 0"}}),_c('path',{attrs:{"data-name":"Path 6811","d":"M25.379 8.176a2.017 2.017 0 114.034 0"}})]),_c('path',{attrs:{"data-name":"Line 34","d":"M13.007 4.878L14.628.719"}}),_c('path',{attrs:{"data-name":"Line 35","d":"M24.691 4.878L23.07.719"}})])])
          )
        }
      }
    